(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('custom-accordion').then(() => {
    class FooterAccordion extends CustomAccordion {
      constructor() {
        super();
        this.wasDesktop = window.matchMedia('(min-width: 750px)').matches;
        this.updateOpenState();
        window.addEventListener('resizeend', this.updateOpenState.bind(this));
      }

      updateOpenState() {
        if (window.matchMedia('(min-width: 750px)').matches) {
          this.detailsElem.open = true;
          this.summaryElem.setAttribute('tabindex', '-1');
          this.summaryElem.classList.add('pointer-events-none');
          this.wasDesktop = true;
        } else if (this.wasDesktop) {
          this.detailsElem.open = false;
          this.summaryElem.removeAttribute('tabindex');
          this.summaryElem.classList.remove('pointer-events-none');
          this.wasDesktop = false;
        }
      }
    }

    customElements.define('footer-accordion', FooterAccordion);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const SEARCH_SELECTOR = '[data-integrated-header-search]';
    const MOBILE_QUERY = '(max-width: 749.98px)';
    const DESKTOP_STICKY_TOP_GAP = 10;

    const getFocusable = (container) => [...container.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), summary, [tabindex]:not([tabindex="-1"])'
    )].filter((element) => !element.hidden && element.getClientRects().length > 0);

    const setSurroundingContentInert = (details, makeInert) => {
      const header = details.closest('.header');
      if (!header) return;

      if (!makeInert) {
        header.querySelectorAll('[data-header-search-inert]').forEach((element) => {
          element.inert = false;
          element.removeAttribute('data-header-search-inert');
        });
        return;
      }

      let branch = details;
      while (branch && branch !== header) {
        const parent = branch.parentElement;
        if (!parent) break;

        [...parent.children].forEach((sibling) => {
          if (sibling === branch || sibling.hasAttribute('data-header-search-inert')) return;
          sibling.inert = true;
          sibling.setAttribute('data-header-search-inert', '');
        });

        branch = parent;
      }
    };

    const closeIntegratedSearch = (details, restoreFocus = false) => {
      if (!details?.open) return;
      details.removeAttribute('open');
      const summary = details.querySelector(':scope > summary');
      summary?.setAttribute('aria-expanded', 'false');
      if (restoreFocus) summary?.focus({ preventScroll: true });
    };

    const closeHeaderMenus = (wrapper) => {
      wrapper?.querySelectorAll('header-menu details[open], header-drawer details[open]').forEach((menu) => {
        menu.removeAttribute('open');
      });
      wrapper?.classList.remove('header-menu-open');
    };

    const bindIntegratedSearch = (scope = document) => {
      scope.querySelectorAll(`${SEARCH_SELECTOR}:not([data-search-bound])`).forEach((details) => {
        details.dataset.searchBound = 'true';

        const wrapper = details.closest('.header-wrapper');
        const summary = details.querySelector(':scope > summary');
        const input = details.querySelector('input[type="search"]');
        const closeButton = details.querySelector('[data-integrated-search-close]');

        details.addEventListener('toggle', () => {
          summary?.setAttribute('aria-expanded', String(details.open));
          wrapper?.classList.toggle('header-search-open', details.open);

          if (!details.open) {
            setSurroundingContentInert(details, false);
            return;
          }

          document.querySelectorAll(`${SEARCH_SELECTOR}[open]`).forEach((other) => {
            if (other !== details) closeIntegratedSearch(other);
          });

          closeHeaderMenus(wrapper);
          setSurroundingContentInert(details, true);
          requestAnimationFrame(() => input?.focus({ preventScroll: true }));
        });

        details.addEventListener('keydown', (event) => {
          if (event.key !== 'Tab' || !details.open) return;
          const panel = details.querySelector('.header-integrated-search__panel');
          const focusable = panel ? getFocusable(panel) : [];
          if (!focusable.length) return;

          const first = focusable[0];
          const last = focusable[focusable.length - 1];

          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        });

        closeButton?.addEventListener('click', (event) => {
          event.preventDefault();
          closeIntegratedSearch(details, true);
        });
      });
    };

    bindIntegratedSearch();

    if (!window.__vroomyHeaderSearchEventsBound) {
      window.__vroomyHeaderSearchEventsBound = true;

      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        document.querySelectorAll(`${SEARCH_SELECTOR}[open]`).forEach((details) => {
          closeIntegratedSearch(details, true);
        });
      });

      document.addEventListener('pointerdown', (event) => {
        document.querySelectorAll(`${SEARCH_SELECTOR}[open]`).forEach((details) => {
          if (!details.contains(event.target)) closeIntegratedSearch(details);
        });
      });

      document.addEventListener('shopify:section:load', (event) => {
        bindIntegratedSearch(event.target);
      });
    }

    class StickyHeader extends HTMLElement {
      constructor() {
        super();
        this.onScroll = this.onScroll.bind(this);
        this.measure = this.measure.bind(this);
        this.onViewportChange = this.onViewportChange.bind(this);
        this.onResize = this.onResize.bind(this);
        this.onDrawerToggle = this.onDrawerToggle.bind(this);
        this.captureDesktopStickyStart = this.captureDesktopStickyStart.bind(this);
        this.updateDesktopHeaderGap = this.updateDesktopHeaderGap.bind(this);
        this.clearDesktopHeaderGap = this.clearDesktopHeaderGap.bind(this);
        this.preventRevealHandler = () => { this.preventReveal = true; };
      }

      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.section = this.closest('.section-header');
        if (!this.section) return;

        this.type = this.getAttribute('data-sticky-type') || 'none';
        this.alwaysSticky = this.type === 'always';
        this.mobileTransparent = this.hasAttribute('data-mobile-transparent');
        this.mobileMedia = window.matchMedia(MOBILE_QUERY);
        this.desktopMedia = window.matchMedia('(min-width: 750px)');
        this.currentScrollTop = Math.max(window.scrollY || 0, 0);
        this.lastDirection = '';
        this.preventReveal = false;
        this.rafId = 0;
        this.headerHeight = 0;
        this.lastViewportWidth = Math.round(window.innerWidth || document.documentElement.clientWidth || 0);
        this.mobileSolidState = null;

        this.addEventListener('preventHeaderReveal', this.preventRevealHandler);

        this.drawerDetails = [...this.querySelectorAll('header-drawer > details')];
        this.drawerDetails.forEach((details) => details.addEventListener('toggle', this.onDrawerToggle));

        this.measure();

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(this.measure);
          this.resizeObserver.observe(this);
        } else {
          window.addEventListener('resize', this.measure, { passive: true });
        }

        this.mobileMedia.addEventListener?.('change', this.onViewportChange);
        this.desktopMedia.addEventListener?.('change', this.onViewportChange);
        window.addEventListener('resize', this.onResize, { passive: true });

        requestAnimationFrame(() => {
          this.captureDesktopStickyStart();
          this.update(true);
        });

        document.fonts?.ready.then(() => {
          this.measure();
          this.captureDesktopStickyStart();
          this.update(true);
        }).catch(() => {});
        window.addEventListener('load', this.measure, { once: true, passive: true });
        window.addEventListener('load', this.captureDesktopStickyStart, { once: true, passive: true });

        if (this.alwaysSticky && !this.isMobileTransparentMode()) {
          this.section.classList.add('shopify-section-header-sticky');
        }

        this.scrollListening = false;
        this.syncScrollListener();
        this.update(true);
      }

      disconnectedCallback() {
        this.initialized = false;
        this.removeEventListener('preventHeaderReveal', this.preventRevealHandler);
        if (this.scrollListening) {
          window.removeEventListener('scroll', this.onScroll);
          this.scrollListening = false;
        }
        window.removeEventListener('resize', this.measure);
        window.removeEventListener('resize', this.onResize);
        this.mobileMedia?.removeEventListener?.('change', this.onViewportChange);
        this.desktopMedia?.removeEventListener?.('change', this.onViewportChange);
        this.drawerDetails?.forEach((details) => details.removeEventListener('toggle', this.onDrawerToggle));
        if (this.rafId) cancelAnimationFrame(this.rafId);
        this.resizeObserver?.disconnect();
        this.clearDesktopHeaderGap();
      }

      clearDesktopHeaderGap() {
        if (!this.section) return;
        this.section.classList.remove('vroomy-desktop-header-flush');
        this.section.style.removeProperty('--vroomy-desktop-header-gap');
      }

      getNaturalDocumentTop(element) {
        let top = 0;
        let node = element;

        while (node) {
          top += Number(node.offsetTop || 0);
          node = node.offsetParent;
        }

        return top;
      }

      captureDesktopStickyStart() {
        if (!this.section || !this.alwaysSticky || !this.desktopMedia?.matches) {
          this.desktopStickyStart = undefined;
          this.clearDesktopHeaderGap();
          return;
        }

        /* Remove only our correction before measuring the untouched theme
           position. This keeps the correct desktop start layout unchanged. */
        this.clearDesktopHeaderGap();

        const scrollTop = Math.max(window.scrollY || 0, 0);
        const naturalFlowTop = this.getNaturalDocumentTop(this.section);
        const currentVisualDocumentTop = this.section.getBoundingClientRect().top + scrollTop;

        /* At the top, the visual position also captures any theme spacing
           below the announcement bar. When remeasuring mid-page, offsetTop
           remains the stable natural anchor. */
        const visualTopAtPageStart = scrollTop <= 5 ? currentVisualDocumentTop : 0;
        this.desktopStickyStart = Math.max(
          1,
          Math.round(Math.max(naturalFlowTop, visualTopAtPageStart))
        );

        this.updateDesktopHeaderGap(scrollTop, true);
      }

      updateDesktopHeaderGap(scrollTop = Math.max(window.scrollY || 0, 0), forceMeasure = false) {
        if (!this.section || !this.alwaysSticky || !this.desktopMedia?.matches) {
          this.clearDesktopHeaderGap();
          return;
        }

        if (this.desktopStickyStart === undefined) {
          const naturalFlowTop = this.getNaturalDocumentTop(this.section);
          this.desktopStickyStart = Math.max(1, Math.round(naturalFlowTop));
        }

        const shouldFlush = scrollTop >= this.desktopStickyStart;

        if (!shouldFlush) {
          this.clearDesktopHeaderGap();
          return;
        }

        if (
          this.section.classList.contains('vroomy-desktop-header-flush') &&
          !forceMeasure
        ) {
          return;
        }

        /* Measure the actual visible header, not a guessed announcement-bar
           height. Remove only the excess gap and intentionally preserve a
           small 10px floating space below the top of the viewport. */
        this.clearDesktopHeaderGap();
        const remainingGap = Math.max(0, Math.round(this.getBoundingClientRect().top));
        const correction = Math.max(0, remainingGap - DESKTOP_STICKY_TOP_GAP);

        this.section.style.setProperty(
          '--vroomy-desktop-header-gap',
          `${correction}px`
        );
        this.section.classList.add('vroomy-desktop-header-flush');
      }

      updateMobileVisualState(scrollTop, force = false) {
        if (!this.isMobileTransparentMode()) {
          if (force || this.mobileSolidState !== null) {
            this.classList.remove('is-scrolled');
            this.mobileSolidState = null;
          }
          return;
        }

        const shouldTurnSolid = scrollTop > 1;

        /* During normal scrolling the visual state usually does not change.
           Exit immediately so the scroll handler performs no DOM writes. */
        if (!force && shouldTurnSolid === this.mobileSolidState) return;

        this.classList.toggle('is-scrolled', shouldTurnSolid);
        this.mobileSolidState = shouldTurnSolid;

        this.section.classList.remove(
          'shopify-section-header-hidden',
          'shopify-section-header-sticky',
          'scrolled-past-header',
          'scrolling-down',
          'scrolling-up',
          'animate'
        );

        document.documentElement.style.setProperty('--header-height-live', '0px');
      }

      isMobileTransparentMode() {
        return this.mobileTransparent && this.mobileMedia.matches;
      }

      onResize() {
        const nextWidth = Math.round(window.innerWidth || document.documentElement.clientWidth || 0);

        /* Mobile browsers emit height-only resize events while their address
           bar moves. Ignore those events; width changes still trigger a full
           responsive recalculation. */
        if (Math.abs(nextWidth - this.lastViewportWidth) < 2) return;

        this.lastViewportWidth = nextWidth;
        this.onViewportChange();
      }

      onViewportChange() {
        this.syncScrollListener();
        this.measure();
        this.captureDesktopStickyStart();
        this.update(true);
      }

      syncScrollListener() {
        const shouldListen =
          this.type === 'on-scroll-up' ||
          (this.mobileTransparent && this.mobileMedia.matches) ||
          (this.alwaysSticky && this.desktopMedia.matches);

        if (shouldListen && !this.scrollListening) {
          window.addEventListener('scroll', this.onScroll, { passive: true });
          this.scrollListening = true;
        } else if (!shouldListen && this.scrollListening) {
          window.removeEventListener('scroll', this.onScroll);
          this.scrollListening = false;
        }
      }

      onDrawerToggle() {
        const drawerOpen = this.drawerDetails.some((details) => details.open);
        this.classList.toggle('header-menu-open', drawerOpen);

        if (drawerOpen) {
          this.querySelectorAll(`${SEARCH_SELECTOR}[open]`).forEach((details) => {
            closeIntegratedSearch(details);
          });
        }
      }

      measure() {
        const height = Math.round(this.getBoundingClientRect().height || 0);
        if (height && height !== this.headerHeight) {
          this.headerHeight = height;
          document.documentElement.style.setProperty('--header-height', `${height}px`);
        }

        if (this.isMobileTransparentMode()) {
          document.documentElement.style.setProperty('--header-height-live', '0px');
        } else if (!this.section.classList.contains('shopify-section-header-hidden')) {
          document.documentElement.style.setProperty('--header-height-live', `${this.headerHeight}px`);
        }
      }

      onScroll() {
        /*
         * On mobile the only work is a single class toggle at the first
         * scroll pixel. Run it directly so it cannot arrive one frame late.
         * Desktop keeps requestAnimationFrame for its measured gap correction.
         */
        if (this.isMobileTransparentMode()) {
          const scrollTop = Math.max(window.scrollY || 0, 0);
          this.currentScrollTop = scrollTop;
          this.updateMobileVisualState(scrollTop);
          return;
        }

        if (this.rafId) return;
        this.rafId = requestAnimationFrame(() => {
          this.rafId = 0;
          this.update();
        });
      }

      update(force = false) {
        const scrollTop = Math.max(window.scrollY || 0, 0);
        const delta = scrollTop - this.currentScrollTop;
        this.currentScrollTop = scrollTop;

        const mobileTransparentMode = this.isMobileTransparentMode();

        if (mobileTransparentMode) {
          this.updateMobileVisualState(scrollTop, force);
          return;
        }

        this.updateDesktopHeaderGap(scrollTop);

        const searchOpen = Boolean(this.querySelector(`${SEARCH_SELECTOR}[open]`));
        const predictiveSearchOpen = Boolean(
          [...this.querySelectorAll('predictive-search')].some((search) => search.isOpen)
        );

        if (searchOpen || predictiveSearchOpen) {
          this.reveal(false);
          return;
        }

        if (this.alwaysSticky) {
          this.reveal(false);
          return;
        }

        if (this.type === 'none') {
          if (mobileTransparentMode) {
            this.reveal(false);
          } else if (force) {
            this.reset(false);
          }
          return;
        }

        const topThreshold = Math.max(this.headerHeight, 1);
        if (scrollTop <= topThreshold) {
          this.reset(false);
          return;
        }

        this.section.classList.add('scrolled-past-header');

        if (!force && Math.abs(delta) < 3) return;

        if (delta > 0) {
          this.setDirection('down');
          if (!this.preventReveal) this.hide();
        } else {
          this.setDirection('up');

          if (this.preventReveal) {
            this.preventReveal = false;
            this.hide();
          } else {
            this.reveal(false);
          }
        }
      }

      setDirection(direction) {
        if (this.lastDirection === direction) return;
        this.lastDirection = direction;
        this.section.classList.toggle('scrolling-down', direction === 'down');
        this.section.classList.toggle('scrolling-up', direction === 'up');
      }

      hide() {
        this.section.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
        this.section.classList.remove('animate');
        document.documentElement.style.setProperty('--header-height-live', '0px');
        this.closeMenuDisclosure();
      }

      reveal(atTop = false) {
        this.section.classList.remove('shopify-section-header-hidden');
        this.section.classList.add('shopify-section-header-sticky');
        this.section.classList.toggle('animate', !atTop);

        if (this.isMobileTransparentMode()) {
          document.documentElement.style.setProperty('--header-height-live', '0px');
        } else {
          document.documentElement.style.setProperty('--header-height-live', `${this.headerHeight}px`);
        }
      }

      reset(mobileTransparentTop = false) {
        this.lastDirection = '';
        this.preventReveal = false;
        this.section.classList.remove(
          'shopify-section-header-hidden',
          'animate',
          'scrolled-past-header',
          'scrolling-down',
          'scrolling-up'
        );

        this.section.classList.toggle('shopify-section-header-sticky', this.alwaysSticky);
        document.documentElement.style.setProperty(
          '--header-height-live',
          mobileTransparentTop ? '0px' : `${this.headerHeight}px`
        );
      }

      closeMenuDisclosure() {
        this.querySelectorAll('header-menu').forEach((menu) => {
          if (typeof menu.close === 'function') {
            menu.close();
          } else {
            menu.querySelector('details[open]')?.removeAttribute('open');
          }
        });
      }
    }

    if (!customElements.get('sticky-header')) {
      customElements.define('sticky-header', StickyHeader);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
